<div>
    <canvas  id="chartZone">
        <!-- {{chartZone}} -->
    </canvas>
</div>